import { render, staticRenderFns } from "./larval_site.vue?vue&type=template&id=6f561f86&"
import script from "./larval_site.vue?vue&type=script&lang=js&"
export * from "./larval_site.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports